import React, { useState } from 'react';
import TitlePointWorkflow from './TitlePointWorkflow';
import TitlePointAPITester from './TitlePointAPITester';
import TitlePointTransactionHistory from './TitlePointTransactionHistory';
import './TitlePoint.css';

function TitlePoint({ onBack }) {
  const [activeView, setActiveView] = useState('tester'); // Default to 'tester' since workflow is disabled

  return (
    <div className="titlepoint-container">
      <div className="titlepoint-nav">
        <button
          className={activeView === 'workflow' ? 'active disabled' : 'disabled'}
          disabled={true}
          title="Coming Soon - Currently in development"
        >
          Production Workflow (Coming Soon)
        </button>
        <button
          className={activeView === 'tester' ? 'active' : ''}
          onClick={() => setActiveView('tester')}
        >
          Endpoint Tester
        </button>
        <button
          className={activeView === 'history' ? 'active' : ''}
          onClick={() => setActiveView('history')}
        >
          Transaction History
        </button>
      </div>

      {activeView === 'workflow' ? (
        <div className="coming-soon-message">
          <h2>Production Workflow - Coming Soon</h2>
          <p>This feature is currently in development. Please use the Endpoint Tester and Transaction History tabs to manually execute TitlePoint workflows.</p>
        </div>
      ) : activeView === 'tester' ? (
        <TitlePointAPITester onBack={null} />
      ) : (
        <TitlePointTransactionHistory onBack={null} />
      )}
    </div>
  );
}

export default TitlePoint;
